







import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SfTableHeading',
  inject: ['table'],
  mounted() {
    if (!this.$slots.default) return;
    (this.table as any).updateColumnsCount(
      this.$slots.default.filter((node) => node.tag).length
    );
  },
});
